import type { ReactNode } from 'react';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';

interface AppShellProps {
  children: ReactNode;
  /** When true, renders the platform-level sidebar (super_admin only). */
  platformMode?: boolean;
}

/**
 * Editorial two-column shell: a narrow institutional sidebar
 * on the left with a persistent "newspaper masthead" topbar
 * above the main content.
 */
export function AppShell({ children, platformMode = false }: AppShellProps) {
  return (
    <div className="relative flex min-h-screen bg-[var(--color-paper)] text-[var(--color-ink)]">
      <Sidebar platformMode={platformMode} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main
          id="main"
          className="relative min-w-0 flex-1 overflow-x-hidden bg-white"
          tabIndex={-1}
        >
          {/* Subtle grain overlay for texture — keeps it from feeling flat */}
          <div
            aria-hidden
            className="pointer-events-none fixed inset-0 z-0 opacity-[0.025] mix-blend-multiply"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
            }}
          />
          <div className="relative z-10">{children}</div>
        </main>
      </div>
    </div>
  );
}
